export default __webpack_public_path__ + "static/media/italy.08db2cd1.svg";